export enum ActionTypes {
    EDIT = "EDIT",
    DELETE = "DELETE",
    SET_AS_COMPLETE = "SET_AS_COMPLETE",
    NOTIFY = "NOTIFY"
}